<template>
  <div v-if="show" class="absolute right-0 mt-2 w-96 bg-white border border-gray-300 rounded-md shadow-lg z-50">
    <ul class="list-none p-2 max-h-96 overflow-y-auto" @scroll="$emit('scroll')">
      <li v-for="(notification, index) in notifications"
          :key="notification.id"
          :class="[
        'p-2 border-b last:border-b-0 hover:bg-gray-100',
        {
          'font-semibold': notification.read_at === null,
          'font-normal': notification.read_at !== null
        }
      ]"
      >
        <Link
          class="flex items-center"
          :href="route('tickets.edit', notification.data.uid)"
          @click.prevent="$emit('markAsRead', notification)">
          <div class="flex items-center w-8/12 cursor-pointer">
          <span class="h-2 w-2 rounded-full mr-4"
                :class="{'bg-red-500': notification.read_at === null, 'bg-transparent': notification.read_at !== null}">
          </span>
            <div>
              <div class="font-semibold">{{ getTicketLabel(notification) }}</div>
              <div class="text-sm text-gray-600">{{ __("Ticket") }} #{{ notification.data.uid }}</div>
            </div>
          </div>
          <div class="w-4/12 text-right flex flex-col items-end justify-start">
            <div class="text-xs text-gray-500">{{ moment(notification.created_at).fromNow() }}</div>
          </div>
        </Link>
      </li>
      <li v-if="loading" class="p-2 text-center text-gray-500">Loading...</li>
      <li v-if="!loading && notifications.length === 0" class="p-2 text-center text-gray-500">No notifications</li>
    </ul>

    <div class="p-2 border-t">
      <button
        class="w-full text-sm text-blue-700 hover:underline text-center"
        @click="$emit('markAllAsRead')"
      >
        {{ __("Mark all as read") }}
      </button>
    </div>
  </div>
</template>

<script>
import {Link} from "@inertiajs/vue3";
import moment from 'moment';

export default {
  components: {Link},
  props: {
    notifications: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getTicketLabel(notification) {
      return notification.data.notification || "Ticket Notification";
    }
  },
  created() {
    this.moment = moment;
  },
}
</script>
